import React from 'react';
import Badge from '../common/Badge';
import { statusVariant } from '../../utils/statusVariant';

export const StatusBadge = ({ status }: { status: string }) => (
    <Badge variant={statusVariant(status)} size="sm">{status}</Badge>
);

export const GavelIcon = ({ size, className }: { size: number, className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="m14 13-7.5 7.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L11 10" />
        <path d="m16 16 6-6" />
        <path d="m8 8 6-6" />
        <path d="m9 7 8 8" />
        <path d="m21 11-8-8" />
    </svg>
);
